import Events from '../../events'

class WorkspaceInvestigations {
  constructor($scope, workspaceInteractor) {
    this.$scope = $scope;
    this.workspaceInteractor = workspaceInteractor;
  }

  $onInit() {
    this.loadInvestigations();
    this.$scope.$on(Events.UPDATE_WORKSPACE_INVESTIGATIONS, () => this.loadInvestigations());
  }

  loadInvestigations() {
    return this.workspaceInteractor.investigationsOfWorkspace(this.workspace.id)
      .then(investigations => {
        this.investigations = investigations;
        this.$scope.$digest();
      });
  }

  reloadInvestigations() {
    this.loadInvestigations().then(() => this.updateInvestigations());
  }
}

export default {
  name: 'workspaceInvestigations',
  obj: {
    controller: WorkspaceInvestigations,
    bindings: {
      workspace: '<',
      updateInvestigations: '&',
      showClosedInvestigations: '<',
      showOpenInvestigations: '<'
    },
    template: `
      <open-investigations ng-if="$ctrl.showOpenInvestigations"
                           investigations="$ctrl.investigations"
                           update-investigations="$ctrl.reloadInvestigations()"
                           workspace-id="$ctrl.workspace.id"></open-investigations>
                           
      <completed-investigations ng-if="$ctrl.showClosedInvestigations"
                                investigations="$ctrl.investigations"></completed-investigations>
    `
  }

}